import globalStore from '$$store/main';
import app from '$$app';

function onCalendarIntegrationDeleted(event) {
  if (+GT.user.id === +event.data.userId) {
    if (event.data.type === 'google') {
      globalStore.commit('integrationGoogle/removeLink', event.data.id);
    } else {
      globalStore.commit('integrationOutlook/removeLink', event.data.id);
    }
  }
  app.trigger('onAfterCollaboration', {
    event: event.event,
    data: event.data,
  });
}

export default onCalendarIntegrationDeleted;
